import type { ElementType } from 'react'
import { Button } from '../../components/ui'
import type { SettingsAreaDefinition, SettingsAreaId, SettingsTabDefinition, SettingsTabId } from './settingsStructure'

interface SettingsTabNavItem extends SettingsTabDefinition {
  icon: ElementType
}

interface SettingsNavigationProps {
  areas: SettingsAreaDefinition[]
  tabs: SettingsTabNavItem[]
  activeArea: SettingsAreaId
  activeTab: SettingsTabId
  onAreaChange: (nextArea: SettingsAreaId) => void
  onTabChange: (nextTab: SettingsTabId) => void
}

export default function SettingsNavigation({
  areas,
  tabs,
  activeArea,
  activeTab,
  onAreaChange,
  onTabChange
}: SettingsNavigationProps) {
  const visibleTabs = tabs.filter((tab) => tab.visible)
  const activeAreaTabs = visibleTabs.filter((tab) => tab.area === activeArea)

  return (
    <div className="mb-6 space-y-3">
      <div className="card p-3">
        <div className="flex flex-wrap gap-2">
          {areas.map((area) => (
            <Button
              key={area.id}
              size="sm"
              variant={activeArea === area.id ? 'primary' : 'outline'}
              onClick={() => onAreaChange(area.id)}
            >
              {area.label}
            </Button>
          ))}
        </div>
      </div>

      <div className="card p-3">
        <div className="flex flex-wrap gap-2">
          {activeAreaTabs.map((tab) => {
            const Icon = tab.icon
            return (
              <Button
                key={tab.id}
                size="sm"
                variant={activeTab === tab.id ? 'primary' : 'outline'}
                onClick={() => onTabChange(tab.id)}
                className="inline-flex items-center gap-2"
              >
                <Icon className="h-4 w-4" />
                {tab.label}
              </Button>
            )
          })}
        </div>
      </div>
    </div>
  )
}
